import type { CommonStrings } from "../../types";

export const common: CommonStrings = {
  nav: {
    blog: "博客",
    github: "GitHub",
    productHunt: "Product Hunt",
  },
  footer: {
    blog: "博客",
    privacy: "隐私政策",
    impressum: "Impressum",
    github: "GitHub",
  },
  aria: {
    themeToLight: "切换到浅色模式",
    themeToDark: "切换到深色模式",
    prevTheme: "上一个主题",
    nextTheme: "下一个主题",
    language: "更改语言",
  },
};
